var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 189.948h-32c-8.284 0-15 6.716-15 15v220c0 8.284 6.716 15 15 15h32c8.284 0 15-6.716 15-15v-220c0-8.284-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.04 95.281 25-43.301c5.523-9.566 2.245-21.798-7.321-27.321l-17.32-10c-9.566-5.523-21.798-2.245-27.32 7.321l-25 43.301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.817 351.301c8.571 4.886 19.508 1.695 24.441-6.849l122.581-212.316c-11.435-2.717-23.639-.3-33.242 6.902l-42.467 31.85c-12.358 9.269-22.626 21.037-30.134 34.537l-54.543 98.076c-9.363 16.836-3.49 38.07 13.193 47.702.057.033.114.065.171.098z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.76 300.092h65.032l103.248-178.831-51.962-30-120.661 208.993c1.437-.096 2.882-.162 4.343-.162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.437 393.75-15.519 26.88c-.73 1.264-1.271 2.628-1.607 4.049l-14.311 60.532c-2.739 11.585 11.244 19.658 19.908 11.494l45.268-42.659c1.062-1.001 1.973-2.152 2.703-3.417l12.27-21.252c-21.421-3.188-39.457-16.867-48.712-35.627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.13 430.092h-94.753l-19.798 34.29c6.366 6.598 15.293 10.709 25.185 10.709 19.33 0 35-15.67 35-35 0 19.33 15.67 35 35 35 19.33 0 35-15.67 35-35v-2.285c-3.631-1.661-11.946-5.885-15.634-7.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.815 162.597-79.383 137.495h23.568c8.284 0 15 6.716 15 15 0 8.283-6.714 14.999-14.998 15h-123.242c-19.33 0-35 15.67-35 35 0 19.33 15.67 35 35 35h126.448l16.59 8.288c28.39 14.196 60.191 21.711 91.964 21.711 26.323 0 53.534-5.173 78.239-15.015v-194.987h-23.641z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.7e88dc378aac2428d8acb10497af9234.svg";
export { ForwardRef as ReactComponent };